<template>
  <b-card>
    <!-- form -->
    <b-form @submit.prevent="passwordChange">
      <b-row>
        <!-- old password -->
        <b-col md="6">
          <b-form-group
            :label="$t('Old Password')"
            label-for="account-old-password"
          >
            <b-input-group class="input-group-merge"
                           :class="{ invalid: errors && ('oldPassword' in errors) }">
              <b-form-input
                id="account-old-password"
                v-model="passwordValueOld"
                name="old-password"
                :type="passwordFieldTypeOld"
                :placeholder="$t('Old Password')"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconOld"
                  class="cursor-pointer"
                  @click="togglePasswordOld"
                />
              </b-input-group-append>
            </b-input-group>
            <small v-if="errors && ('oldPassword' in errors)" class="text-danger">
              {{ $t(errors['oldPassword'][0]) }}
            </small>
          </b-form-group>
        </b-col>
        <!--/ old password -->
      </b-row>
      <b-row>
        <!-- new password -->
        <b-col md="6">
          <b-form-group
            label-for="account-new-password"
            :label="$t('New Password')"
          >
            <b-input-group class="input-group-merge"
                           :class="{ invalid: errors && ('password' in errors) }">
              <b-form-input
                id="account-new-password"
                v-model="newPasswordValue"
                :type="passwordFieldTypeNew"
                name="new-password"
                :placeholder="$t('New Password')"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
            <small v-if="errors && ('password' in errors)" class="text-danger">
              {{ $t(errors['password'][0]) }}
            </small>
          </b-form-group>
        </b-col>
        <!--/ new password -->

        <!-- retype password -->
        <b-col md="6">
          <b-form-group
            label-for="account-retype-new-password"
            :label="$t('Retype New Password')"
          >
            <b-input-group class="input-group-merge"
                           :class="{ invalid: errors && ('password' in errors) }">
              <b-form-input
                id="account-retype-new-password"
                v-model="RetypePassword"
                :type="passwordFieldTypeRetype"
                name="retype-password"
                :placeholder="$t('Retype New Password')"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconRetype"
                  class="cursor-pointer"
                  @click="togglePasswordRetype"
                />
              </b-input-group-append>
            </b-input-group>
            <small v-if="errors && ('password_confirmation' in errors)" class="text-danger">
              {{ $t(errors['password_confirmation'][0]) }}
            </small>
          </b-form-group>
        </b-col>
        <!--/ retype password -->

        <!-- buttons -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            type="submit"
          >
            {{ $t('Change Password')}}
          </b-button>
        </b-col>
        <!--/ buttons -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    passwordPost: {
      type: Function
    },
    errors: {
      type: Object
    }
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
  },


  setup(props) {

    const passwordValueOld = ref('')
    const newPasswordValue = ref('')
    const RetypePassword = ref('')


    const passwordChange = () => {
      props.passwordPost({ current_password: passwordValueOld.value ,
        password: newPasswordValue.value, password_confirmation: RetypePassword.value})
    }

    return {
      passwordValueOld,
      newPasswordValue,
      RetypePassword,
      passwordChange
    }

  }
}
</script>

<style lang="scss">

.invalid {
  border-radius: 0.357rem;
  border: 1px solid #ea5455 !important;
  svg {
    color: #ea5455;
  }
}

</style>
